<template>
  <div class="el-custom-select">
    <el-select v-model="store.cycle" v-if="store.recurring" class="w-100" placeholder="Select Recurring Cycle">
      <el-option
        v-for="(opt, key) in props.options"
        :key="key"
        :value="key"
        :label="opt"
      >
        {{ opt }}
      </el-option>
    </el-select>
  </div>
</template>

<script setup lang="ts">
import { useDonationFormsStore } from '../store';
const props = defineProps({
  options: {
      type: Object,
      default: () => {
        return {
          weekly: 'Weekly',
          monthly: 'Monthly',
          quarterly: 'Quarterly',
          yearly: 'Yearly',
        }
      }
    }
});
const store = useDonationFormsStore();



</script>
